interface TeamBadgeProps {
  short: string;
  color: string;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "w-7 h-7 text-[10px]",
  md: "w-10 h-10 text-xs",
  lg: "w-14 h-14 text-sm",
};

export default function TeamBadge({ short, color, size = "md" }: TeamBadgeProps) {
  return (
    <span
      className={`${sizeMap[size]} rounded-full flex items-center justify-center font-label font-semibold text-white tracking-wide shrink-0`}
      style={{ backgroundColor: color }}
    >
      {short}
    </span>
  );
}